import { ReactNode, useRef } from 'react';
import classNames from 'classnames';

import { FormError } from '@ui/FormError';
import { InputLabel } from '@ui/InputLabel';

import s from './Input.sss';

const themes = {
  default: s.themeDefault,
  transparent: s.themeTransparent,
};

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
  label?: string
  error?: React.ReactNode
  helpText?: React.ReactNode
  theme?: keyof typeof themes;
  inputClassName?: string,
  prefix?: ReactNode,
  suffix?: ReactNode,
};

export const Input: React.FC<InputProps> = ({
  className,
  required,
  invalid,
  label,
  error,
  helpText,
  type,
  theme = 'default',
  inputClassName,
  prefix,
  suffix,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const hasError = Array.isArray(error) ? !!error.length : !!error;
  return (
    <div
      className={classNames(
        s.root,
        { [s.invalid]: invalid || hasError },
        themes[theme],
        className,
      )}
    >
      {label
        && (
        <InputLabel
          className={s.label}
          onClick={() => inputRef.current!.focus()}
          required={required}
        >
          {label}
        </InputLabel>
        )}
      <div className={s.inputIconGroup}>
        {prefix}

        <input
          ref={inputRef}
          type={type}
          className={classNames(
            s.input,
            inputClassName,
          )}
          required={required}
          {...props}
        />

        {suffix}
      </div>
      {helpText && <div className={s.helpText}>{helpText}</div>}
      {error && (
        Array.isArray(error)
          ? error.map((e, i) => <FormError key={i}>{e}</FormError>)
          : <FormError>{error}</FormError>
      )}
    </div>
  );
};

export default Input;
